import { z } from 'zod';

import { statisticsSummaryValueSchema } from './statistics-summary';

/**
 * Represents the available metrics for the team statistics summary.
 */
export enum TeamStatisticsSummaryMetric {
  FGA = 'FGA', // FGA
  FGP = 'FGP', // FG%
  THREEPA = 'THREEPA', // 3PA
  THREEPP = 'THREEPP', // 3P%
}

export type TeamStatisticsSummary = z.infer<typeof teamStatisticsSummarySchema>;

/**
 * Represents a summary of team statistics, where each metric is mapped to its corresponding value.
 */
export const teamStatisticsSummarySchema = z.record(
  z.enum(TeamStatisticsSummaryMetric),
  statisticsSummaryValueSchema,
);
